import {damsFetch} from "../app/damsFetch";
import decamelizeKeysDeep from "decamelize-keys-deep";
import {clientLog} from "../clientLog";
import {createPlaceObject} from "./createPlaceObject";
import {useDocumentTranslation} from "../documents/documentContext";
import {useSnackbar} from "notistack";

export const useAddPlace = () => {

    const t = useDocumentTranslation();
    const {enqueueSnackbar} = useSnackbar();

    const callback = json => {
        return Promise.resolve(createPlaceObject(json));
    };

    const errorCallback = error => {
        clientLog('error', error, 'useAddPlace');
        enqueueSnackbar(t("savePlaceFailTitle", "Feil ved lagring av sted"), {variant: 'error'});
    };

    const _isDamsObject = (obj) => {
        return obj.hasOwnProperty('name') && obj.hasOwnProperty('placeType');
    };

    const _setTitle = (place, isDamsObject) => {
        if (isDamsObject) {
            return place.name;
        } else {
            return place?.content?.name || place?.name;
        }
    }

    const _setContent = (place, isDamsObject) => {
        if (isDamsObject) {
            return {
                name: place.name,
                name_and_title: `${place.name} (${place.placeType})`,
                place_type: place.placeType
            };
        } else {
            return place?.content || {};
        }
    };

    const _savePlace = async (place, callback) => {
        const res = await damsFetch(`/documents`, {
            method: "POST",
            body: JSON.stringify(decamelizeKeysDeep(place)),
        });
        return callback(res);
    };

    return async ({places, _locale = "no"}) => {
        const savedPlaces = [];
        for (let i = 0, max = places.length; i < max; i++) {
            try {
                const place = places[i];
                const {collectionId, source, sourceId} = place;

                const isDamsObject = _isDamsObject(places[i]);
                const title = _setTitle(place, isDamsObject);
                const content = _setContent(place, isDamsObject);

                const newPlace = {
                    collectionId: collectionId,
                    schemaId: 1,
                    locale: _locale,
                    _action: "put",
                    title: title,
                    status: "published",
                    source: source,
                    sourceId: sourceId,
                    documentType: "place",
                    content: content
                };
                savedPlaces.push(await _savePlace(newPlace, callback));
            } catch (e) {
                errorCallback(e);
            }
        }
        return savedPlaces;
    };
};
